<template>
  <div :class="classes">
    <slot name="content"></slot>
  </div>
</template>

<script>
  export default {
    name: 'slidein',
    props: {
      extraClasses: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String,
        default: 'default',
      },
    },
    computed: {
      classes() {
        let result = ['slidein']
        result = result.concat(this.extraClasses)
        if (this.$store.getters.slideinVisible(this.type)) {
          result.push('slidein--visible')
        }
        return result.join(' ')
      },
    },
  }
</script>

<style lang="scss">
  $slidein-menu-width: 360px;
  $slidein-menu-bg: $white;
  $slidein-menu-wider-factor: 1.25;

  $slidein-menu-bp--slidein: $bp-lg - 1px;
  $slidein-menu-bp--slidein-sm: $bp-xs;
  $slidein-menu-bp--top-menu: $bp-lg;
  $slidein-menu-offset-x: 110%;

  .slidein {
    position: fixed;
    z-index: 3000;
    transition: $transition-base;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    background-color: $slidein-menu-bg;
    top: 0;
    left: 0;
    // We're pushing the slidein an extra 10% to the side to hide the shadow.
    transform: translateX(-1 * $slidein-menu-offset-x);
    box-shadow: 2px 2px 7px rgba(0, 0, 0, 0.3);

    $padding-h: spacer(3);
    padding: spacer(3) 0;

    @media (min-width: $bp-sm) {
      max-width: 360px;
      left: auto;
      right: 0;
      transform: translateX($slidein-menu-offset-x);
    }

    &.slidein--visible {
      transform: translateX(0);
    }

    &__header {
      position: relative;
      text-align: center;
      margin-bottom: spacer(1);

      @media (min-width: $bp-sm) {
        margin-bottom: spacer(3);
      }
    }

    &__cube {
      text-align: center;
      margin-bottom: spacer(3);

      &-icon {
        width: $sidebar-width-min * 0.5;
      }

      &-nickname {
        display: block;
        font-size: $font-size-lg;
        font-weight: bold;
      }
    }

    &__headline {
      margin: 0 0 spacer(0.5);
      padding: 0 $padding-h;
      font-size: $font-size-base;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
    }

    &__close {
      display: inline-block;
      width: spacer(1);
      position: absolute;
      left: $padding-h;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
      color: $black;
      opacity: 0.8;
      transition: $transition-base;

      @media (min-width: $bp-sm) {
        width: spacer(2);
        transform: translateY(-50%);
      }

      .icon {
        vertical-align: middle;
      }

      &:hover,
      &:focus,
      &:active {
        color: $black;
      }
    }

    &__logo {
      &-img {
        max-width: 100px;

        @media (min-width: $bp-sm) {
          max-width: 100px;
        }
      }
    }

    &__list {
      list-style: none;
      margin: 0 0 spacer(4);
      padding: 0;

      &-item {
        border-top: 1px solid $grey-lighter;
        padding: 0 $padding-h;

        &:last-child {
          border-bottom: 1px solid $grey-lighter;
        }
      }
    }

    &__link {
      display: flex;
      justify-content: space-between;
      align-items: center;
      line-height: 3em;
      color: $grey-darker;
      font-size: $font-size-base;
      transition: $transition-base;

      @media (min-width: $bp-sm) {
        line-height: 3em;
        font-size: $font-size-md;
      }

      &:hover,
      &:active,
      &:focus {
        color: $black;

        .icon--arrow {
          transform: translateX(0.5em);
          color: $grey-dark;
        }
      }

      &-notifications {
        background: $notification-color;
        color: $white;
        width: 1.5rem;
        height: 1.5rem;
        border-radius: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        font-weight: $font-weight-bold;
        margin-left: auto;
        // The circle we're creating here is replacing the arrow visualizing
        // that clicking on this links gets somewhere else.
        // The circle is a bit wider than the arrow would be. So to align the
        // circle's center with the one of the arrow we push it a bit to the right.
        margin-right: -0.35rem;
      }

      .icon--arrow {
        width: 0.75em;
        color: $grey-light;
        transition: $transition-base;
        // Allow the notification dot to be position left of the arrow.
        order: 2;
      }

      &--selected-cube {
        .icon {
          transition: $transition-base;
          width: 0.75em;
          color: $black;
        }
      }
    }
  }

  // Handling state when the slidein is visible.
  .app {
    &--slidein-visible {
      @media (max-width: $slidein-menu-bp--slidein) {
        overflow: hidden;
        position: fixed;
        left: 0;
        right: 0;
      }
    }
  }

  .slidein-overlay {
    touch-action: none;
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    overflow: hidden;
    width: 0;
    height: 0;
    opacity: 0;
    background: $black;
    transition: opacity 0.3s, width 0s 0.3s, height 0s 0.3s;

    .app--slidein-visible & {
      width: 100%;
      height: 100%;
      opacity: 0.3;
      transition: opacity 0.3s;
    }
  }
</style>
